import axios from "axios";

let navigate = null;
export const setApiNavigate = (nav) => {
  navigate = nav;
};

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 10000,
    withCredentials: true
});


// Request interceptor to add token to headers
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor (optional) for handling errors globally
api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 403) {
        console.log("token invalid")
        localStorage.removeItem('token');
        localStorage.removeItem('userDetails');
        if (navigate) {
            // Redirect to session-timeout page
            navigate('/session-timeout', { replace: true });
        } else {
            // No token at all (unauthenticated)
            navigate('/sign-in', { replace: true });
        }
      }
      return Promise.reject(error);
    }
);

export default api;